import { useNavigate } from "react-router-dom";
import { ProposalWizard, TEAM_WIZARD } from "./PartnerNewProposal";

/** Assistant « nouvelle proposition depuis un modèle » de l'équipe : mêmes étapes que le portail partenaire, puis l'éditeur. */
export default function TeamNewProposal() {
  const navigate = useNavigate();
  return <ProposalWizard config={TEAM_WIZARD} onCreated={(p) => navigate(`/proposals/${p.id}/edit`)} />;
}
